import React from 'react';

const REGIONS = {
  kanto:  { label: 'Kanto (Gen 1)' },
  johto:  { label: 'Johto (Gen 2)' },
  hoenn:  { label: 'Hoenn (Gen 3)' },
  sinnoh: { label: 'Sinnoh (Gen 4)' },
  unova:  { label: 'Unova (Gen 5)' },
  kalos:  { label: 'Kalos (Gen 6)' },
  alola:  { label: 'Alola (Gen 7)' },
  galar:  { label: 'Galar (Gen 8)' },
  paldea: { label: 'Paldea (Gen 9)' },
};

const ALL_REGION_KEYS = Object.keys(REGIONS);

function RegionSelect({ selectedRegions, onRegionsChange, boardSize, onBoardSizeChange }) {
  const allSelected = selectedRegions.length === ALL_REGION_KEYS.length;

  const toggleAll = () => {
    onRegionsChange(allSelected ? [] : [...ALL_REGION_KEYS]);
  };

  const toggleRegion = (key) => {
    if (selectedRegions.includes(key)) {
      onRegionsChange(selectedRegions.filter(r => r !== key));
    } else {
      onRegionsChange([...selectedRegions, key]);
    }
  };

  return (
    <div className="region-select">
      <h3 className="region-select-title">Game Settings</h3>

      <div className="region-group">
        <label className="region-label">Regions</label>
        <label className="region-checkbox select-all">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={toggleAll}
          />
          <span>Select All</span>
        </label>
        <div className="region-grid">
          {ALL_REGION_KEYS.map((key) => (
            <label key={key} className="region-checkbox">
              <input
                type="checkbox"
                checked={selectedRegions.includes(key)}
                onChange={() => toggleRegion(key)}
              />
              <span>{REGIONS[key].label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="board-size-group">
        <label className="region-label">Board Size</label>
        <div className="board-size-options">
          <label className="board-size-option">
            <input
              type="radio"
              name="boardSize"
              value={24}
              checked={boardSize === 24}
              onChange={() => onBoardSizeChange(24)}
            />
            <span>24 Pokemon</span>
          </label>
          <label className="board-size-option">
            <input
              type="radio"
              name="boardSize"
              value={36}
              checked={boardSize === 36}
              onChange={() => onBoardSizeChange(36)}
            />
            <span>36 Pokemon</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default RegionSelect;
